import React, {useEffect, useState} from "react";
import Dropdown from 'react-bootstrap/Dropdown';
import {mdiNavigationVariantOutline, mdiMapMarker, mdiGoogleMaps, mdiWaze, mdiPhoneDial} from "@mdi/js";
import Icon from "@mdi/react";
import {AddressType} from "../types/Address";

export default function NavigationDropdown({address}: {address: AddressType | null}) {

    if (!address) { return null; }

    const contacts = address.ContactPersons.filter((person: {
        ContactPersonPhone: string,
        ContactPerson: string
    }) => person.ContactPersonPhone !== '');

    const navigateWith = async (platform: 'Sygic' | 'iGo' | 'Waze' | 'Google') => {
        let url = '';

        switch (platform) {
            case "Sygic":
                url = 'com.sygic.aura://coordinateaddr|' + address.Longitude + '|' + address.Latitude + '|' + address.FullAddress + '|drive';
                break;
            case "iGo":
                url = 'igomyway://G' + address.Latitude + ';' + address.Longitude;
                break;
            case "Waze":
                url = 'https://waze.com/ul?ll=' + address.Latitude + ',' + address.Longitude + '&navigate=yes';
                break;
            case "Google":
                url = 'https://maps.google.com/maps?q=loc:' + address.Latitude + ',' + address.Longitude + '(' + address.FullAddress + ')';
                break;
        }

        try {
            window.open(url, '_blank', 'noopener,noreferrer');
        } catch (e) {
            alert(e);
        }
    }

    return (
        <>
            {contacts.length > 0 && (
                <Dropdown drop="down-centered">
                    <Dropdown.Toggle variant="link" className="hide-btn-after">
                        <Icon className="text-primary" path={mdiPhoneDial} size={1.2}/>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        {contacts.map((person, index) => (
                            <Dropdown.Item
                                key={index}
                                onClick={() => window.open(`tel:${person.ContactPersonPhone}`, '_self')}
                            >
                                {person.ContactPerson !== '' ? person.ContactPerson : person.ContactPersonPhone}
                            </Dropdown.Item>
                        ))}
                    </Dropdown.Menu>
                </Dropdown>
            )}

            <Dropdown drop="down-centered">
                <Dropdown.Toggle variant="link" className="hide-btn-after">
                    <Icon className="text-primary" path={mdiNavigationVariantOutline} size={1.2}/>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    <Dropdown.Item onClick={() => navigateWith('Sygic')}><Icon className="text-primary me-2 mb-2" path={mdiMapMarker} size={1}/>Sygic</Dropdown.Item>
                    <Dropdown.Item onClick={() => navigateWith('iGo')}><Icon className="text-primary me-2 mb-2" path={mdiNavigationVariantOutline} size={1}/>iGo</Dropdown.Item>
                    <Dropdown.Item onClick={() => navigateWith('Waze')}><Icon className="text-primary me-2 mb-2" path={mdiWaze} size={1}/>Waze</Dropdown.Item>
                    <Dropdown.Item onClick={() => navigateWith('Google')}><Icon className="text-primary me-2 mb-2" path={mdiGoogleMaps} size={1}/>Google</Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        </>
    );
}